import { useTranslation } from 'react-i18next'

import { observer } from 'mobx-react-lite'

import { InputRange, RangePrice } from 'features/input-range'

import { findExcursionsStore } from 'entities/excursions/models/find-excursions/find-excursions-store'

import { BlockArrow } from 'shared/ui/block-arrow'
import { BlockSelect, TYPE_RESULT } from 'shared/ui/block-select'
import { ButtonContinue } from 'shared/ui/bottom-continue'
import { HeaderResetButton } from 'shared/ui/header-reset-button'

import s from './styles.module.scss'

interface IList {
  key: string
  title: string
}

type Props = {
  onBack: () => void
  onReset: () => void
  priceRange: RangePrice
  onSubmit: () => void
  listDuration: IList[]
  listTypeOfExcursions?: IList[]
  listDifficult: IList[]
  onChangeDuration: (value: string | string[]) => void
  onChangeDifficult: (value: string | string[]) => void
  showGuides: () => void
  onRangePrice: (data: RangePrice) => void
  onSelectTypeExcursions: (data: string | string[]) => void
}

export const FilterUi = observer(
  ({
    onBack,
    onReset,
    priceRange,
    onSubmit,
    listDuration,
    listTypeOfExcursions,
    listDifficult,
    onChangeDuration,
    onChangeDifficult,
    showGuides,
    onRangePrice,
    onSelectTypeExcursions,
  }: Props) => {
    const { t } = useTranslation()

    const { filter } = findExcursionsStore.findExcursions

    return (
      <div>
        <div className={s.container}>
          <div className={s.header}>
            <HeaderResetButton
              title={t('filter')}
              onBack={onBack}
              onReset={onReset}
              isCanDisable={!!filter}
            />
          </div>

          <div className={s.wrapperFilterItem}>
            <InputRange
              title={t('price')}
              label={t('label_price')}
              min={priceRange?.min}
              max={priceRange?.max}
              value={[priceRange?.min, priceRange?.max]}
              onChange={(value) =>
                onRangePrice({
                  min: value[0],
                  max: value[1],
                })
              }
            />

            <div className={s.itemBlock}>
              <BlockSelect
                listOption={listDuration}
                typeOption={TYPE_RESULT.RADIO}
                active={[filter?.duration || '']}
                title={t('excursions.duration')}
                onChange={onChangeDuration}
              />
            </div>

            {listTypeOfExcursions ? (
              <div className={s.itemBlock}>
                <BlockSelect
                  title={t('excursions.excursion')}
                  listOption={listTypeOfExcursions}
                  typeOption={TYPE_RESULT.CHECK_BOX}
                  onChange={onSelectTypeExcursions}
                  active={filter?.types_excursions}
                />
              </div>
            ) : null}

            <div className={s.itemBlock}>
              <BlockSelect
                title={t('excursions.difficult_lvl')}
                listOption={listDifficult}
                typeOption={TYPE_RESULT.RADIO}
                active={[filter?.difficulty_level || '']}
                onChange={onChangeDifficult}
              />
            </div>

            <BlockArrow
              text={t('excursions.guides')}
              onClick={showGuides}
            />

            <ButtonContinue onClick={onSubmit}>
              <span className={s.text}>{t('apply')}</span>
            </ButtonContinue>
          </div>
        </div>
      </div>
    )
  },
)
